import {ChangeDetectionStrategy, Component, signal} from '@angular/core';

@Component({
  selector: 'app-cpru-become',
  templateUrl: './cpru-become.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block md:rounded-lg md:border md:border-grey-9 md:bg-white md:px-4 md:py-5',
  },
})
export class CpruBecomeComponent {
  public isExpanded = signal<boolean>(false);

  public toggleExpand() {
    this.isExpanded.set(!this.isExpanded());
  }
}
